import { Row, Column } from '../../components'
import SearchPanel from './SearchPanel'
import { ErrorBoundary } from 'react-error-boundary'

const CustomerAdvancedSearch = () => {
  const FallbackComponent = ({ error, resetErrorBoundary }) => {
    console.log('An error occurred:')
    console.log(error.message)
    return (
      <div>
        <h1>An error occurred: {error.message}</h1>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    )
  }

  return (
    <Row className="bg-light">
      <Column lg={12} md={12}>
        <ErrorBoundary FallbackComponent={FallbackComponent}>
          <SearchPanel collapsible isAdvancedSearchFilter={true}></SearchPanel>
        </ErrorBoundary>
      </Column>
    </Row>
  )
}

export default CustomerAdvancedSearch
